import './App.css';
import { useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import * as AuthAPI from './services/authAPI';
import AuthContext from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Sidebar from './components/Sidebar';
import HomePage from './pages/HomePage';
import LabelPage from './pages/LabelPage';
import ProfilePage from './pages/ProfilePage';


AuthAPI.setup();

function App() {

    const navigate = useNavigate();

    const [isAuthenticated, setIsAuthenticated] = useState(AuthAPI.isAuthenticated());

	
    const user = AuthAPI.setup();
    const id = user?.id;
    const firstName = user?.firstName;
    const lastName = user?.lastName;
    const role = user?.role;

    return (
        <AuthContext.Provider value={{
            isAuthenticated,
            setIsAuthenticated
        }}>
            <div className="App d-flex">
                {isAuthenticated === true && <Sidebar
                    navigate={navigate}
                    id={id}
                    firstName={firstName}
                    lastName={lastName}
                    role={role}
                />}
                <div className={`main-content flex-grow-1 ${isAuthenticated ? 'with-sidebar' : ''}`}>
                    <div className="container-fluid p-4">
                        <Routes>
                            <Route path="/login" element={<LoginPage navigate={navigate} />} />
                            <Route element={<PrivateRoute />}>
                                <Route path="/" element={<HomePage />} />
								<Route path="/label" element={<LabelPage />} />
                                <Route path="/profile" element={<ProfilePage />} />
                            </Route>
                            
                        </Routes>
                    </div>
                </div>
            </div>
        </AuthContext.Provider>
    );
}

export default App;